import { useState, useEffect } from "react";
import "../assets/css/staffLink.css";
import logo from "../assets/img/apply_logo.png";


import loanBg from "../assets/img/background_image.png";
import { useParams } from "react-router-dom";

import {
  ShieldCheck,
  UserRoundCheck,
  Check
} from "lucide-react";

import GlobalLoader from "../components/GlobalLoader";

import { useRef } from "react";

const RUNNING_LOAN_API = `${process.env.REACT_APP_API_BASE}/loans/check_running_loan.php`;


const LOAN_SETTINGS_API = `${process.env.REACT_APP_API_BASE}/loans/loan_settings.php`;
/* ===============================
   LOAN PRODUCT CONFIG
=============================== */



const formatAmount = (value) => {

  

  const digits = value.replace(/\D/g, "");
  return digits.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
};

const unformatAmount = (value) => value.replace(/,/g, "");

const NIGERIAN_BANKS = [
  "Access Bank",
  "Citibank Nigeria",
  "Ecobank Nigeria",
  "Fidelity Bank",
  "First Bank of Nigeria",
  "First City Monument Bank (FCMB)",
  "Globus Bank",
  "Guaranty Trust Bank (GTBank)",
  "Heritage Bank",
  "Keystone Bank",
  "Polaris Bank",
  "Providus Bank",
  "Stanbic IBTC Bank",
  "Standard Chartered Bank",
  "Sterling Bank",
  "SunTrust Bank",
  "Titan Trust Bank",
  "Union Bank of Nigeria",
  "United Bank for Africa (UBA)",
  "Unity Bank",
  "Wema Bank",
  "Zenith Bank",
  "Jaiz Bank",
  "TAJ Bank",
  "Kuda Bank",
  "Opay",
  "Moniepoint Microfinance Bank",
  "PalmPay",
];

/* ===============================
   UPLOAD LABELS
=============================== */
const UPLOAD_LABELS = {
  passport: "Passport Photograph",
  id_card: "Official Identification Card",
  payslip: "Last Month Payslip",
bank_statement: "Bank Statement",
consent_form: "Signed Consent Form",
  asset_photo: "Asset Photograph",
  business_docs: "Business Documents",
  signature: "Signature",
};

function UploadField({
  label,
  name,
  required = true,
  accept = "image/jpeg,image/png,application/pdf",
  value,
  onChange,
  withCamera = false,
}) {
  const inputRef = useRef(null);
  const cameraRef = useRef(null);
  const [preview, setPreview] = useState(null);

  useEffect(() => {
    if (!value) {
      setPreview(null);
      return;
    }

    if (value.type?.startsWith("image/")) {
      const objectUrl = URL.createObjectURL(value);
      setPreview(objectUrl);
      return () => URL.revokeObjectURL(objectUrl);
    } else {
      setPreview(null);
    }
  }, [value]);

  return (
    <div className={`upload-card ${value ? "has-file" : ""}`}>
      <div className="upload-title">
        {label} {required && <span className="required">*</span>}
      </div>

      <div className="upload-sub">
        {value
          ? `${value.name} (${Math.round(value.size / 1024)} KB)`
          : "Upload 1 supported file. Max 10 MB."}
      </div>

      {preview && (
        <div className="upload-preview">
          <img
            src={preview}
            alt="preview"
            style={{
              width: "100%",
              maxHeight: "180px",
              objectFit: "cover",
              marginTop: "10px",
              borderRadius: "8px",
            }}
          />
        </div>
      )}

      <div style={{ display: "flex", gap: "10px", flexWrap: "wrap" }}>
        <button
          type="button"
          className="upload-btn"
          onClick={() => inputRef.current.click()}
        >
          ⬆ {value ? "Change file" : "Upload"}
        </button>

        {withCamera && (
          <button
            type="button"
            className="upload-btn camera-btn"
            onClick={() => cameraRef.current.click()}
          >
            📸 Snap
          </button>
        )}
      </div>

      <input
        ref={inputRef}
        type="file"
        name={name}
        accept={accept}
        hidden
        onChange={(e) => {
          const file = e.target.files?.[0];
          if (file) {
            onChange({
              target: {
                name,
                value: file,
              },
            });
          }
        }}
      />

      {withCamera && (
        <input
          ref={cameraRef}
          type="file"
          accept="image/*"
          capture="environment"
          hidden
          onChange={(e) => {
            const file = e.target.files?.[0];
            if (file) {
              onChange({
                target: {
                  name,
                  value: file,
                },
              });
            }
          }}
        />
      )}
    </div>
  );
}





export default function StaffLink() {



const IMAGE_UPLOADS = [
  "passport",
  "id_card",
  "asset_photo",
  "signature",
  "payslip",
  "consent_form"
];


const getInitials = (name) => {
  if (!name) return "•";

  return name
    .trim()
    .split(/\s+/)
    .map(part => part.charAt(0).toUpperCase())
    .slice(0, 2)
    .join("");
};

  const maskNumber = (v) =>
  v ? v.replace(/\d(?=\d{4})/g, "*") : "";

const removeFile = (field) => {
  setForm((p) => ({ ...p, [field]: null }));
};


const resetForm = () => {
  setShowSuccessModal(false);
  setShowConfirmModal(false);
  setStep(1);
  setSelectedProduct("");
  setTrackingId("");
  setErrors({});
  setForm({
    first_name: "",
    last_name: "",
    phone: "",
    email: "",
    bvn: "",
    nin: "",
    loan_amount: "",
    loan_tenor: "",
    bank_name: "",
account_number: "",
    passport: null,
    id_card: null,
    payslip: null,
    bank_statement: null,
    consent_form: null,
    asset_photo: null,
    business_docs: null,
    signature: null,
    account_officer_code: "",
    account_officer_name: "",
    account_officer_email: "",
  });
};

  const { staffId } = useParams();
  const isPersonalizedLink = Boolean(staffId);

  const [step, setStep] = useState(1);
  const [selectedProduct, setSelectedProduct] = useState("");
  const [loanProducts, setLoanProducts] = useState([]);
  const [errors, setErrors] = useState({});
  const [showSuccessModal, setShowSuccessModal] = useState(false);

  const [officerLoading, setOfficerLoading] = useState(false);
  const [officerLoaded, setOfficerLoaded] = useState(false);

  const [trackingId, setTrackingId] = useState("");

  const [showConfirmModal, setShowConfirmModal] = useState(false);

const [submitting, setSubmitting] = useState(false);

const [checkingLoan, setCheckingLoan] = useState(false);
const [runningLoan, setRunningLoan] = useState(null);
const [showRunningLoanModal, setShowRunningLoanModal] = useState(false);
const [runningLoanProceed, setRunningLoanProceed] = useState(false);


const fetchLoanProducts = async () => {
  try {
    const res = await fetch(LOAN_SETTINGS_API, {
      method: "GET",
      credentials: "include",
    });

    const data = await res.json();

    if (data.success) {
      setLoanProducts(data.products || []);
    }
  } catch (err) {
    console.error("Fetch loan products error:", err);
  }
};

useEffect(() => {
  fetchLoanProducts();
}, []);

useEffect(() => {
  if (submitting || showSuccessModal || showConfirmModal || showRunningLoanModal) {
    document.body.style.overflow = "hidden";
    document.documentElement.style.overflow = "hidden";
  } else {
    document.body.style.overflow = "";
    document.documentElement.style.overflow = "";
  }

  return () => {
    document.body.style.overflow = "";
    document.documentElement.style.overflow = "";
  };
}, [submitting, showSuccessModal, showConfirmModal, showRunningLoanModal]);

const isAdult = (dob) => {
  const birth = new Date(dob);
  const today = new Date();
  let age = today.getFullYear() - birth.getFullYear();
  const m = today.getMonth() - birth.getMonth();
  if (m < 0 || (m === 0 && today.getDate() < birth.getDate())) age--;
  return age >= 18;
};


const [form, setForm] = useState({
  first_name: "",
  last_name: "",
  dob: "",
   gender: "", 
  phone: "",
  other_phone: "",
  email: "",
  bvn: "",
  nin: "",
  address: "",
  state_of_origin: "",
  next_of_kin: "",
  nok_phone: "",

  employer: "",
  ippis_number: "",
  date_of_employment: "",
  grade_level: "",

  business_name: "",
  business_address: "",
  rc_number: "",

  loan_amount: "",
  loan_tenor: "",
 bank_name: "",        // ✅ ADD THIS
  account_number: "",   // ✅ ADD THIS
  passport: null,
  id_card: null,
  payslip: null,
  bank_statement: null,
  consent_form: null,
  asset_photo: null,
  business_docs: null,
  signature: null,

  account_officer_code: "",
  account_officer_name: "",
  account_officer_email: "",
});

  /* ===============================
     FETCH ACCOUNT OFFICER
  =============================== */


useEffect(() => {
  if (!staffId) return;

  setOfficerLoading(true);
  setOfficerLoaded(false);

  fetch(`${process.env.REACT_APP_API_BASE}/get_employee.php?id=${staffId}`)
    .then(res => res.json())
    .then(data => {
      if (!data.success) {
        setOfficerLoaded(false);
        return;
      }

      setForm(prev => ({
        ...prev,
        account_officer_code: data.data.employee_no,
        account_officer_name: data.data.name,
        account_officer_email: data.data.email,
      }));

      setOfficerLoaded(true); // ✅ THIS IS WHAT YOU WERE MISSING
    })
    .catch(err => {
      console.error("Employee fetch failed:", err);
      setOfficerLoaded(false);
    })
    .finally(() => {
      setOfficerLoading(false);
    });

}, [staffId]);
  

const runningLoanCalc = runningLoan?.loan
  ? {
      principalBalance: Number(runningLoan.loan.principal_balance || 0),
      interestAmount: Number(runningLoan.loan.interest_amount || 0),
      liquidationFee: Number(runningLoan.loan.liquidation_fee || 0),
      totalPayoff: Number(runningLoan.loan.total_payoff_balance || 0),
      paidMonths: Number(runningLoan.loan.paid_months || 0),
    }
  : null;

const totalPrincipalToSettle = runningLoanCalc
  ? runningLoanCalc.totalPayoff
  : 0;

const requestedLoanAmount = Number(unformatAmount(form.loan_amount || "0"));


const selectedProductDetails = loanProducts.find(
  (p) => p.product_name === selectedProduct
);

const upfrontFeeRate = Number(
  selectedProductDetails?.upfront_fee_rate ??
  selectedProductDetails?.upfrontFeeRate ??
  0
);

const balanceAfterSettlement = Math.max(
  requestedLoanAmount - totalPrincipalToSettle,
  0
);

const upfrontFeeBaseAmount =
  runningLoanProceed && runningLoan
    ? balanceAfterSettlement
    : requestedLoanAmount;

const upfrontFeeAmount = (upfrontFeeBaseAmount * upfrontFeeRate) / 100;

const productConfig = selectedProduct
  ? {
      label: selectedProduct,
      uploads:
        selectedProduct.toUpperCase().includes("IPPIS")
          ? ["passport", "id_card", "payslip", "consent_form", "signature"]
          : selectedProduct.toUpperCase().includes("ASSET")
          ? ["passport", "id_card", "bank_statement", "consent_form", "asset_photo", "signature"]
          : selectedProduct.toUpperCase().includes("SME")
          ? ["passport", "id_card", "bank_statement", "consent_form", "business_docs", "signature"]
          : ["passport", "id_card", "bank_statement", "consent_form", "signature"],
    }
  : null;


  const isTopUp = runningLoanProceed && runningLoan;

const topUpRequiredUploads = ["consent_form"];

const requiredUploads = isTopUp
  ? topUpRequiredUploads
  : productConfig?.uploads || [];

const estimatedDisbursement = Math.max(
  upfrontFeeBaseAmount - upfrontFeeAmount,
  0
);


  const handleChange = (e) => {
    const { name, value, files } = e.target;
    setForm((p) => ({ ...p, [name]: files ? files[0] : value }));
    setErrors((p) => ({ ...p, [name]: "" }));
  };


const checkRunningLoan = async () => {
  setCheckingLoan(true);

  try {
    const params = new URLSearchParams({
      bvn: form.bvn,
      nin: form.nin,
    });

    const res = await fetch(`${RUNNING_LOAN_API}?${params.toString()}`, {
      method: "GET",
      credentials: "include",
    });

    const data = await res.json();

    if (data.success === true && data.has_running_loan === true) {
    setRunningLoan(data);

setForm((prev) => ({
  ...prev,
  bank_name: data.loan?.bank_name || "",
  account_number: data.loan?.bank_account || "",
}));

setShowRunningLoanModal(true);
      setStep(1);
      return true;
    }

    return false;
  } catch (err) {
    console.error("Running loan check failed:", err);
    setErrors({ general: "Could not check running loan. Please try again." });
    return true;
  } finally {
    setCheckingLoan(false);
  }
};

const goToNextStep = async (e) => {
  e.preventDefault();

  const err = {};

if (form.bvn.length !== 11) err.bvn = "BVN must be 11 digits";
if (form.nin.length !== 11) err.nin = "NIN must be 11 digits";

  setErrors(err);

  if (Object.keys(err).length) return;

  const hasRunningLoan = await checkRunningLoan();

if (!hasRunningLoan) {
  setRunningLoanProceed(false);
  setStep(2); // product selection page
}
};

  const submitLoan = async () => {
  if (!selectedProduct) return;
  if (submitting) return;

  setSubmitting(true);

  const newErrors = {};
  const allowedTypes = ["image/jpeg", "image/png", "application/pdf"];

  if (runningLoanProceed && runningLoan) {
  if (!form.loan_amount) {
    newErrors.loan_amount = "Loan amount is required";
  }

  if (!form.loan_tenor) {
    newErrors.loan_tenor = "Loan tenor is required";
  }

  if (!form.bank_name) {
  newErrors.bank_name = "Please select a bank";
}

if (!/^\d{10}$/.test(form.account_number)) {
  newErrors.account_number = "Account number must be 10 digits";
}

if (!form.consent_form) {
  newErrors.consent_form = "Signed consent form is required";
}
  if (estimatedDisbursement <= 0) {
    newErrors.loan_amount = "Loan amount must be greater than payoff amount";
  }

  setErrors(newErrors);

  if (Object.keys(newErrors).length > 0) {
    setSubmitting(false);
    return;
  }
} else {

  if (!form.first_name.trim())
    newErrors.first_name = "First name is required";

  if (!form.last_name.trim())
    newErrors.last_name = "Last name is required";

  if (!form.gender)
  newErrors.gender = "Gender is required";

  if (!form.dob || !isAdult(form.dob))
    newErrors.dob = "Applicant must be at least 18 years old";

  if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(form.email))
    newErrors.email = "Enter a valid email address";

  if (form.phone.length !== 11)
    newErrors.phone = "Phone must be 11 digits";

  if (!form.loan_amount)
    newErrors.loan_amount = "Loan amount is required";

  if (!form.loan_tenor)
    newErrors.loan_tenor = "Loan tenor is required";


  if (!form.bank_name)
  newErrors.bank_name = "Please select a bank";

if (form.account_number.length !== 10)
  newErrors.account_number = "Account number must be 10 digits";

  requiredUploads.forEach((field) => {
    const file = form[field];

    if (!file) {
      newErrors[field] = "This document is required";
    } else if (!allowedTypes.includes(file.type)) {
      newErrors[field] = "Only JPG, PNG or PDF allowed";
    } else if (file.size > 10 * 1024 * 1024) {
      newErrors[field] = "File must not exceed 10MB";
    }
  
  });

}
  setErrors(newErrors);

  if (Object.keys(newErrors).length > 0) {
  const firstError = Object.keys(newErrors)[0];
  const el = document.querySelector(`[name="${firstError}"]`);
  if (el) el.scrollIntoView({ behavior: "smooth", block: "center" });
  setSubmitting(false);
  return;
}



  const fd = new FormData();

  fd.append(
  "application_type",
  runningLoanProceed && runningLoan ? "LIQUIDATION_TOPUP" : "NEW_LOAN"
);

  Object.entries(form).forEach(([key, value]) => {
  if (value !== null && value !== undefined) {
    fd.append(key, value);
  }
});

  fd.append("loan_product", selectedProduct);
  fd.append("loan_amount", unformatAmount(form.loan_amount));
  fd.append("loan_tenor", form.loan_tenor);
  fd.append("upfront_fee_rate", upfrontFeeRate);
fd.append("upfront_fee_amount", upfrontFeeAmount);
  if (staffId) {
  fd.append("staff_id", staffId);
}

if (runningLoanProceed && runningLoan) {
  
  fd.append("existing_loan_id", runningLoan.loan?.id || "");
  fd.append("existing_loan_account", runningLoan.loan?.loan_account || "");
  fd.append("customer_name", runningLoan.loan?.customer_name || "");
fd.append("outstanding_principal", runningLoanCalc?.principalBalance || 0);
fd.append("one_month_interest", runningLoanCalc?.interestAmount || 0);
fd.append("liquidation_fee", runningLoanCalc?.liquidationFee || 0);
fd.append("paid_months", runningLoanCalc?.paidMonths || 0);
fd.append("total_principal_to_settle", totalPrincipalToSettle || 0);
fd.append("estimated_disbursement", estimatedDisbursement || 0);
}

  try {
  const BASE_URL = process.env.REACT_APP_API_BASE;

if (!BASE_URL) {
  setErrors({ general: "Application configuration error." });
  setSubmitting(false);
  return;
}
const res = await fetch(`${BASE_URL}/submit_loan.php`, {
  method: "POST",
  body: fd,
});

const data = await res.json();

if (!res.ok || !data.success) {
  setErrors({ general: data.message || "Submission failed" });
  setSubmitting(false);
  return;
}

    setTrackingId(data.tracking_id);
    setShowSuccessModal(true);

  }catch (error) {
  console.error("Submission error:", error);
  setErrors({ general: "Network error. Please try again." });
} finally {
    setSubmitting(false);
  }
};





  return (
  <>
   {submitting && (
  <div className="submission-overlay">
    <div className="submission-box">
      <div className="submission-spinner"></div>
      <p>Please wait, loan submission processing...</p>
    </div>
  </div>
)}

   <div
  className="apply-loan-page"
  style={{ backgroundImage: `url(${loanBg})` }}
>
      <div className="apply-loan-card">

        {/* HEADER */}
        <div className="loan-header">
          <img src={logo} className="loan-logo" alt="GMT Logo" />
          <h2>GMT Technologies Limited</h2>
          <p>Loan Application</p>
        </div>

        {/* ACCOUNT OFFICER */}
    {isPersonalizedLink && (
  <div className="premium-officer-banner clean-officer-banner">
    
  <div className="officer-avatar">
  {officerLoaded
    ? getInitials(form.account_officer_name)
    : "•"}
</div>

    <div className="officer-details">
      <span className="officer-label">
        Account Officer
      </span>

      <span className="officer-name">
        {officerLoading && "Loading..."}
        {!officerLoading && officerLoaded && form.account_officer_name}
        {!officerLoading && !officerLoaded && "Officer unavailable"}
      </span>
    </div>

    <div className="officer-status-dot"></div>

  </div>
)}

        {/* STEPS */}
      <div className="step-indicator premium-step-indicator">
  {[1, 2, 3].map((item) => (
    <div
      key={item}
      className={`step-item ${
        step === item ? "active" : step > item ? "done" : ""
      }`}
    >
      <span>{step > item ? "✓" : item}</span>
    </div>
  ))}
</div>

        {/* STEP 1 */}
        {step === 1 && (
        <form onSubmit={goToNextStep} className="premium-step-form">

  <div className="loan-step-heading">
  <h5>Loan Selection & Verification</h5>
  <p>
    Verify your identity details to continue your loan application.
  </p>
</div>

 

  {/* =========================
     BVN
  ========================= */}
  <div className="input-with-icon">
  <input
    className={`form-control ${errors.bvn ? "is-invalid" : ""}`}
    placeholder="Enter 11-digit BVN"
    maxLength={11}
    value={form.bvn}
    onChange={(e) =>
      setForm((p) => ({
        ...p,
        bvn: e.target.value.replace(/\D/g, ""),
      }))
    }
  />
<span className="input-icon">
  <ShieldCheck size={18} />
</span>
</div>

  {/* =========================
     NIN
  ========================= */}
<div className="input-with-icon">
  <input
    className={`form-control ${errors.nin ? "is-invalid" : ""}`}
    placeholder="Enter 11-digit NIN"
    maxLength={11}
    value={form.nin}
    onChange={(e) =>
      setForm((p) => ({
        ...p,
        nin: e.target.value.replace(/\D/g, ""),
      }))
    }
  />
  <span className="input-icon">
  <UserRoundCheck size={18} />
</span>
</div>

<button
  type="submit"
  className="premium-continue-btn"
  disabled={
    checkingLoan ||
    form.bvn.length !== 11 ||
    form.nin.length !== 11
  }
>
  {checkingLoan ? (
    <div className="btn-loader"></div>
  ) : (
    <>
      Continue
      <span className="btn-arrow">→</span>
    </>
  )}
</button>


</form>

        )}


        {/* STEP 2 - PRODUCT SELECTION */}
{step === 2 && (
  <div>
    <h5>Select Loan Product</h5>

    <div className="product-card-list">
      {loanProducts.map((item) => (
        <button
          type="button"
          key={item.product_name}
          className={`product-select-card ${
            selectedProduct === item.product_name ? "selected" : ""
          }`}
          onClick={() => {
            setSelectedProduct(item.product_name);
            setErrors((p) => ({ ...p, product: "" }));
          }}
        >
          <div>
            <strong>{item.product_name}</strong>
           <span>Select this loan product</span>
          </div>

      <span className="product-radio">
  {selectedProduct === item.product_name && (
    <span className="product-radio-dot"></span>
  )}
</span>
        </button>
      ))}
    </div>

    {errors.product && (
      <small className="error-text">{errors.product}</small>
    )}

    <div style={{ display: "flex", gap: "12px", marginTop: "16px" }}>
      <button
        type="button"
        className="btn btn-muted w-100"
      onClick={() => setStep(1)}
      >
        Back
      </button>

      <button
        type="button"
        className="btn btn-primary w-100"
        onClick={() => {
          if (!selectedProduct) {
            setErrors((p) => ({
              ...p,
              product: "Please select a loan product",
            }));
            return;
          }

          setStep(3);
        }}
      >
        Continue
      </button>
    </div>
  </div>
)}

      {/* STEP 3 */}
{step === 3 && (
  <form
  onSubmit={(e) => {
    e.preventDefault();
    setShowConfirmModal(true);
  }}
>


{/* =========================
        STEP 1 SUMMARY
    ========================= */}
    <div className="summary-card">
      <strong>Loan Summary</strong>

      <div className="summary-row">
        <span>Loan Product</span>
        <span>{productConfig?.label}</span>
      </div>

      <div className="summary-row">
        <span>BVN</span>
        <span>{maskNumber(form.bvn)}</span>
      </div>

      <div className="summary-row">
        <span>NIN</span>
        <span>{maskNumber(form.nin)}</span>
      </div>

      {form.account_officer_name && (
        <div className="summary-row">
          <span>Account Officer</span>
          <span>{form.account_officer_name}</span>
        </div>
      )}
    </div>

  {/* =========================
     PERSONAL DETAILS

  ========================= */}


  
  <h5>Personal Details</h5>

  <div className="form-grid">
    <div>
      <label className="form-label">First Name</label>
    <input
  className={`form-control ${errors.first_name ? "is-invalid" : ""}`}
  placeholder="First Name"
  name="first_name"
  value={form.first_name}
  onChange={handleChange}
/>

{errors.first_name && (
  <small className="error-text">{errors.first_name}</small>
)}
    </div>

    <div>
      <label className="form-label">Last Name</label>
     <input
  className={`form-control ${errors.last_name ? "is-invalid" : ""}`}
  placeholder="Last Name"
  name="last_name"
  value={form.last_name}
  onChange={handleChange}
/>

{errors.last_name && (
  <small className="error-text">{errors.last_name}</small>
)}
    </div>

    <div>
      <label className="form-label">Date of Birth</label>
     <input
  type="date"
  className={`form-control ${errors.dob ? "is-invalid" : ""}`}
  name="dob"
  value={form.dob}
  onChange={handleChange}
/>

{errors.dob && (
  <small className="error-text">{errors.dob}</small>
)}
    </div>

    <div>
  <label className="form-label">Gender</label>

  <select
    className={`form-control ${errors.gender ? "is-invalid" : ""}`}
    name="gender"
    value={form.gender}
    onChange={handleChange}
  >
    <option value="">Select Gender</option>
    <option value="Male">Male</option>
    <option value="Female">Female</option>
  </select>

  {errors.gender && (
    <small className="error-text">{errors.gender}</small>
  )}
</div>

    <div>
      <label className="form-label">Phone Number</label>
   <input
  className={`form-control ${errors.phone ? "is-invalid" : ""}`}
  placeholder="Phone"
  name="phone"
  value={form.phone}
  onChange={handleChange}
/>

{errors.phone && (
  <small className="error-text">{errors.phone}</small>
)}
    </div>

    <div>
      <label className="form-label">Other Phone Number</label>
      <input
        className="form-control"
        placeholder="Other Phone"
        name="other_phone"
        onChange={handleChange}
      />
    </div>

    <div>
      <label className="form-label">Email Address</label>
 <input
  className={`form-control ${errors.email ? "is-invalid" : ""}`}
  placeholder="Email"
  name="email"
  value={form.email}
  onChange={handleChange}
/>

{errors.email && (
  <small className="error-text">{errors.email}</small>
)}
    </div>
  </div>

  {/* =========================
     ADDRESS
  ========================= */}
  <h5 className="mt-4">Residential Address</h5>

  <div className="mt-2">
    <label className="form-label">Home Address</label>
    <input
      className="form-control"
      placeholder="Home Address"
      name="address"
      onChange={handleChange}
    />
  </div>

  <div className="mt-2">
    <label className="form-label">State of Origin</label>
    <input
      className="form-control"
      placeholder="State of Origin"
      name="state_of_origin"
      onChange={handleChange}
    />
  </div>

  {/* =========================
     NEXT OF KIN
  ========================= */}
  <h5 className="mt-4">Next of Kin</h5>

  <div className="form-grid">
    <div>
      <label className="form-label">Next of Kin Name</label>
      <input
        className="form-control"
        placeholder="Next of Kin"
        name="next_of_kin"
        onChange={handleChange}
      />
    </div>

    <div>
      <label className="form-label">Next of Kin Phone</label>
      <input
        className="form-control"
        placeholder="Next of Kin Phone"
        name="nok_phone"
        onChange={handleChange}
      />
    </div>
  </div>

  {/* =========================
     EMPLOYMENT (IPPIS)
  ========================= */}
  {selectedProduct?.toUpperCase().includes("IPPIS") && (
    <>
      <h5 className="mt-4">Employment Details</h5>

      <div className="form-grid">
        <div>
          <label className="form-label">Employer / Ministry</label>
          <input
            className="form-control"
            placeholder="Employer / Ministry"
            name="employer"
            onChange={handleChange}
          />
        </div>

        <div>
          <label className="form-label">IPPIS Number</label>
          <input
            className="form-control"
            placeholder="IPPIS Number"
            name="ippis_number"
            onChange={handleChange}
          />
        </div>

        <div>
          <label className="form-label">Date of Employment</label>
          <input
            type="date"
            className="form-control"
            name="date_of_employment"
            onChange={handleChange}
          />
        </div>

        <div>
          <label className="form-label">Grade Level</label>
          <input
            className="form-control"
            placeholder="Grade Level"
            name="grade_level"
            onChange={handleChange}
          />
        </div>
      </div>
    </>
  )}

  {/* =========================
     BUSINESS (SME)
  ========================= */}
  {selectedProduct?.toUpperCase().includes("SME") && (
    <>
      <h5 className="mt-4">Business Details</h5>

      <div className="form-grid">
        <div>
          <label className="form-label">Business Name</label>
          <input
            className="form-control"
            placeholder="Business Name"
            name="business_name"
            onChange={handleChange}
          />
        </div>

        <div>
          <label className="form-label">RC Number</label>
          <input
            className="form-control"
            placeholder="RC Number"
            name="rc_number"
            onChange={handleChange}
          />
        </div>
      </div>

      <div className="mt-2">
        <label className="form-label">Business Address</label>
        <input
          className="form-control"
          placeholder="Business Address"
          name="business_address"
          onChange={handleChange}
        />
      </div>
    </>
  )}

  {/* =========================
     LOAN DETAILS
  ========================= */}
  <h5 className="mt-4">Loan Details</h5>

  <div className="form-grid">
  <div>
  <label className="form-label">Loan Amount (₦)</label>

  <input
    name="loan_amount"
    className={`form-control ${errors.loan_amount ? "is-invalid" : ""}`}
    placeholder="Loan Amount"
    value={form.loan_amount}
    onChange={(e) =>
      setForm((p) => ({
        ...p,
        loan_amount: formatAmount(e.target.value),
      }))
    }
  />

  {errors.loan_amount && (
    <small className="error-text">{errors.loan_amount}</small>
  )}
</div>

    <div>
      <label className="form-label">Loan Tenor</label>
   <select
  className={`form-control ${errors.loan_tenor ? "is-invalid" : ""}`}
  name="loan_tenor"
  value={form.loan_tenor}
  onChange={handleChange}
>
  <option value="">Select Loan Tenor</option>

  {[...Array(24)].map((_, i) => {
    const month = i + 1;
    return (
      <option key={month} value={month}>
        {month} {month === 1 ? "Month" : "Months"}
      </option>
    );
  })}
</select>

      {errors.loan_tenor && (
  <small className="error-text">{errors.loan_tenor}</small>
)}
    </div>
  </div>

{runningLoanProceed && runningLoan && (
  <div className="summary-card mt-3">
    <strong>Top-up Calculation</strong>

    <div className="summary-row">
      <span>New Loan Amount</span>
      <span>₦{Number(requestedLoanAmount || 0).toLocaleString()}</span>
    </div>

   <div className="summary-row">
  <span>Total Payoff Balance</span>
  <span>₦{Number(totalPrincipalToSettle || 0).toLocaleString()}</span>
</div>

<div className="summary-row">
  <span>Balance After Settlement</span>
  <span>₦{Number(balanceAfterSettlement || 0).toLocaleString()}</span>
</div>

<div className="summary-row">
  <span>Upfront Fee ({upfrontFeeRate}%)</span>
  <span>₦{Number(upfrontFeeAmount || 0).toLocaleString()}</span>
</div>

<div className="summary-row">
  <strong>Estimated Amount Customer Will Receive</strong>
      <strong>₦{Number(estimatedDisbursement || 0).toLocaleString()}</strong>
    </div>
  </div>
)}

{/* =========================
   BANK DETAILS
========================= */}
<h5 className="mt-4">Bank Details</h5>

<div className="form-grid">

  <div>
    <label className="form-label">Bank Name</label>
    <select
      className={`form-control ${errors.bank_name ? "is-invalid" : ""}`}
      name="bank_name"
      value={form.bank_name}
     onChange={(e) => {
  handleChange(e);
  setForm((p) => ({
    ...p,
    account_number: "", // clear account number when bank changes
  }));
}}
    >
      <option value="">Select Bank</option>
      {NIGERIAN_BANKS.map((bank, index) => (
        <option key={index} value={bank}>
          {bank}
        </option>
      ))}
    </select>

    {errors.bank_name && (
      <small className="error-text">{errors.bank_name}</small>
    )}
  </div>

  <div>
    <label className="form-label">Account Number</label>
    <input
      className={`form-control ${errors.account_number ? "is-invalid" : ""}`}
      name="account_number"
      maxLength={10}
      placeholder="Enter 10-digit account number"
      value={form.account_number}
      onChange={(e) =>
        setForm((p) => ({
          ...p,
          account_number: e.target.value.replace(/\D/g, ""),
        }))
      }
    />

    {errors.account_number && (
      <small className="error-text">{errors.account_number}</small>
    )}
  </div>

</div>
  {/* =========================
     DOCUMENTS
  ========================= */}
  <h5 className="mt-4">Required Documents</h5>

{selectedProduct &&
  requiredUploads.map((field) => (
  <div key={field}>
    <UploadField
      label={UPLOAD_LABELS[field]}
      name={field}
      value={form[field]}
      onChange={handleChange}
      withCamera={IMAGE_UPLOADS.includes(field)}
    />

    {errors[field] && (
      <small className="error-text">{errors[field]}</small>
    )}
  </div>
))}

{errors.general && (
  <div className="error-text" style={{ textAlign: "center", marginTop: "10px" }}>
    {errors.general}
  </div>
)}
<div style={{ display: "flex", gap: "12px", marginTop: "16px" }}>
  <button
    type="button"
    className="btn btn-muted w-100"
    onClick={() => setStep(1)}
    disabled={submitting}
  >
    Back
  </button>

  <button
    type="submit"
    className="btn btn-primary w-100"
    disabled={submitting}
  >
    Submit
  </button>
</div>

</form>

        )}
      </div>


      {showConfirmModal && (
  <div className="loan-modal-overlay">
    <div className="loan-modal">

      <h4>Confirm Loan Application</h4>

      <p style={{ fontSize: "14px", color: "#475569" }}>
        Please review your details before submitting.
      </p>

      <div className="summary-card">
        <div className="summary-row">
          <span>Loan Product</span>
          <span>{productConfig?.label}</span>
        </div>

        <div className="summary-row">
          <span>Loan Amount</span>
          <span>₦{form.loan_amount}</span>
        </div>

        <div className="summary-row">
          <span>Loan Tenor</span>
          <span>{form.loan_tenor} Months</span>
        </div>

        {runningLoanProceed && runningLoan && (
  <>
    <div className="summary-row">
  <span>Total Payoff Balance</span>
  <span>₦{Number(totalPrincipalToSettle || 0).toLocaleString()}</span>
</div>

<div className="summary-row">
  <span>Balance After Settlement</span>
  <span>₦{Number(balanceAfterSettlement || 0).toLocaleString()}</span>
</div>

<div className="summary-row">
  <span>Upfront Fee ({upfrontFeeRate}%)</span>
  <span>₦{Number(upfrontFeeAmount || 0).toLocaleString()}</span>
</div>

<div className="summary-row">
  <strong>Amount Customer Will Receive</strong>
      <strong>₦{Number(estimatedDisbursement || 0).toLocaleString()}</strong>
    </div>
  </>
)}

<div className="summary-row">
  <span>Bank</span>
  <span>{form.bank_name}</span>
</div>

<div className="summary-row">
  <span>Account</span>
  <span>{form.account_number}</span>
</div>
        <div className="summary-row">
          <span>Account Officer</span>
          <span>{form.account_officer_name}</span>
        </div>
      </div>

      <div style={{ display: "flex", gap: "12px", marginTop: "16px" }}>
        <button
          type="button"
          className="btn btn-muted w-100"
          onClick={() => {
  setShowConfirmModal(false);

  if (runningLoanProceed && runningLoan) {
    setShowRunningLoanModal(true);
  }
}}
        >
          Back
        </button>

    <button
  type="button"
  className="btn btn-primary w-100"
  onClick={() => {
    setShowConfirmModal(false);
    submitLoan();
  }}
  disabled={submitting}
>
  Confirm & Submit
</button>
      </div>

    </div>
  </div>
)}


{showRunningLoanModal && runningLoan && (
  <div className="loan-modal-overlay">
   <div className="loan-modal running-loan-modal">
      <h4>Running Loan Settlement</h4>

      <p style={{ fontSize: "14px", color: "#475569" }}>
        You currently have a running loan. To proceed with a new request,
        the current loan must be liquidated.
      </p>

      <div className="summary-card">
        <div className="summary-row">
          <span>Customer</span>
          <span>{runningLoan.loan?.customer_name}</span>
        </div>

        <div className="summary-row">
          <span>Loan Account</span>
          <span>{runningLoan.loan?.loan_account}</span>
        </div>

      <div className="summary-row">
  <span>Principal Balance</span>
  <span>₦{Number(runningLoanCalc?.principalBalance || 0).toLocaleString()}</span>
</div>

<div className="summary-row">
  <span>Interest</span>
  <span>₦{Number(runningLoanCalc?.interestAmount || 0).toLocaleString()}</span>
</div>

<div className="summary-row">
  <span>Liquidation Fee</span>
  <span>₦{Number(runningLoanCalc?.liquidationFee || 0).toLocaleString()}</span>
</div>

<div className="summary-row">
  <strong>Total Payoff Balance</strong>
  <strong>₦{Number(totalPrincipalToSettle || 0).toLocaleString()}</strong>
</div>
      </div>
{runningLoanProceed && (
  <div className="form-grid mt-3">

    <div>
      <label className="form-label">Loan Product</label>
      <select
        className={`form-control ${errors.product ? "is-invalid" : ""}`}
        value={selectedProduct}
        onChange={(e) => {
          setSelectedProduct(e.target.value);
          setErrors((p) => ({ ...p, product: "" }));
        }}
      >
        <option value="">Select Loan Product</option>
        {loanProducts.map((item) => (
          <option key={item.product_name} value={item.product_name}>
            {item.product_name}
          </option>
        ))}
      </select>

      {errors.product && (
        <small className="error-text">{errors.product}</small>
      )}
    </div>

    <div>
      <label className="form-label">New Loan Amount (₦)</label>
      <input
        name="loan_amount"
        className={`form-control ${errors.loan_amount ? "is-invalid" : ""}`}
        placeholder="Enter new loan amount"
        value={form.loan_amount}
        onChange={(e) =>
          setForm((p) => ({
            ...p,
            loan_amount: formatAmount(e.target.value),
          }))
        }
      />
      {errors.loan_amount && (
        <small className="error-text">{errors.loan_amount}</small>
      )}
    </div>

    <div>
      <label className="form-label">Loan Tenor</label>
      <select
        className={`form-control ${errors.loan_tenor ? "is-invalid" : ""}`}
        name="loan_tenor"
        value={form.loan_tenor}
        onChange={handleChange}
      >
        <option value="">Select Loan Tenor</option>
        {[...Array(24)].map((_, i) => {
          const month = i + 1;
          return (
            <option key={month} value={month}>
              {month} {month === 1 ? "Month" : "Months"}
            </option>
          );
        })}
      </select>
      {errors.loan_tenor && (
        <small className="error-text">{errors.loan_tenor}</small>
      )}
    </div>
  </div>
)}


{runningLoanProceed && (
  <>
    <hr />
    <h5>Required Document</h5>

    <UploadField
      label="Signed Consent Form"
      name="consent_form"
      required
      accept="image/jpeg,image/png,application/pdf"
      value={form.consent_form}
      onChange={handleChange}
      withCamera
    />

    {errors.consent_form && (
      <small className="error-text">{errors.consent_form}</small>
    )}
  </>
)}


{runningLoanProceed && (
  <div className="summary-card mt-3">
    <div className="summary-row">
      <span>New Loan Amount</span>
      <span>₦{Number(requestedLoanAmount || 0).toLocaleString()}</span>
    </div>

   <div className="summary-row">
  <span>Total Payoff Balance</span>
  <span>₦{Number(totalPrincipalToSettle || 0).toLocaleString()}</span>
</div>

<div className="summary-row">
  <span>Balance After Settlement</span>
  <span>₦{Number(balanceAfterSettlement || 0).toLocaleString()}</span>
</div>

<div className="summary-row">
  <span>Upfront Fee ({upfrontFeeRate}%)</span>
  <span>₦{Number(upfrontFeeAmount || 0).toLocaleString()}</span>
</div>

<div className="summary-row">
  <strong>Estimated Amount Customer Will Receive</strong>
      <strong>₦{Number(estimatedDisbursement || 0).toLocaleString()}</strong>
    </div>
  </div>
)}

<div style={{ display: "flex", gap: "12px", marginTop: "16px" }}>
  <button
    type="button"
    className="btn btn-muted w-100"
    onClick={() => {
      setShowRunningLoanModal(false);
      setRunningLoanProceed(false);
      setStep(1);
    }}
  >
    Back
  </button>

  <button
    type="button"
    className="btn btn-primary w-100"
    onClick={() => {
    if (!runningLoanProceed) {
  setErrors({});
  setRunningLoanProceed(true);
  return;
}

    const err = {};

    if (!form.bank_name) {
  err.bank_name = "Please select a bank";
}

if (!/^\d{10}$/.test(form.account_number)) {
  err.account_number = "Account number must be 10 digits";
}

if (!form.consent_form) {
  err.consent_form = "Signed consent form is required";
}

if (!selectedProduct) {
  err.product = "Please select a loan product";
}

if (!form.loan_amount) {
        err.loan_amount = "Loan amount is required";
      }

      if (!form.loan_tenor) {
        err.loan_tenor = "Loan tenor is required";
      }

      if (estimatedDisbursement <= 0) {
        err.loan_amount = "Loan amount must be greater than payoff amount";
      }

      setErrors(err);

      if (Object.keys(err).length) return;

      setShowRunningLoanModal(false);
      setShowConfirmModal(true);
    }}
  >
    {runningLoanProceed ? "Submit Loan" : "Proceed"}
  </button>
</div>
    </div>
  </div>
)}

     {showSuccessModal && (
  <div className="loan-modal-overlay">
    <div className="loan-modal">

      <div className="loan-modal-icon">✓</div>

      <h4>Application Submitted</h4>

      <p>
       Thank you{" "}
<strong>
  {runningLoanProceed && runningLoan
    ? runningLoan.loan?.customer_name
    : `${form.first_name} ${form.last_name}`}
</strong>.
        <br />
        Your loan application has been submitted successfully.
      </p>

      <div className="summary-card">
       <div className="summary-row">
  <span>Tracking ID</span>

  <span className="tracking-cell">
    <a
      href={`/track-loan/${trackingId}`}
      target="_blank"
      rel="noopener noreferrer"
      className="tracking-link"
      title="View loan status"
    >
      {trackingId}
    </a>

    <button
      type="button"
      className="copy-btn"
      onClick={() => {
        navigator.clipboard.writeText(trackingId);
      }}
      title="Copy tracking ID"
    >
      Copy
    </button>
  </span>
</div>


        <div className="summary-row">
          <span>Account Officer</span>
          <span>{form.account_officer_name}</span>
        </div>

        <div className="summary-row">
          <span>Email</span>
          <span>{form.account_officer_email}</span>
        </div>
      </div>

      <p style={{ fontSize: "13px", color: "#64748b" }}>
        Our team will review your request and contact you shortly.
      </p>

  <button
  onClick={() => window.location.reload()}
  className="btn btn-primary w-100"
>
  Thank you
</button>


    </div>
  </div>
)}

    </div>
  </>
);
}